export const serializeQueryWithArrayBrackets = (
  params: Record<string, unknown>,
) => {
  const parts: string[] = []

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return
    }

    if (Array.isArray(value) && value.length > 0) {
      value.forEach((item) => {
        if (item !== undefined && item !== null) {
          parts.push(
            `${encodeURIComponent(key)}[]=${encodeURIComponent(String(item))}`,
          )
        }
      })
      return
    }

    parts.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
  })

  return parts.join('&')
}
